export const PLAID_TRANSACTION_CATEGORY_TAXONOMY = {
  INCOME_CHILD_SUPPORT: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Child Support",
    description:
      "Child support refers to court-ordered payments made by a parent to financially support their child’s living expenses",
  },
  INCOME_CONTRACTOR: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Contractor",
    description: "Income from freelance or independent contract work.",
  },
  INCOME_DIVIDENDS: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Dividends",
    description: "Income from dividends",
  },
  INCOME_GIG_ECONOMY: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Gig Economy",
    description:
      "Money earned by working in the gig economy, for example by driving for Lyft, Uber, etc.",
  },
  INCOME_INTEREST_EARNED: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Interest Earned",
    description: "Income from interest on savings accounts",
  },
  INCOME_LONG_TERM_DISABILITY: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Long Term Disability",
    description: "Disability payments, for example from social security.",
  },
  INCOME_MILITARY: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Military",
    description:
      "Money earned from veterans benefits. Salary earned from serving in the military (through DFAS) is categorized as salary",
  },
  INCOME_RENTAL: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Rental",
    description:
      "Rental income includes money earned from payments related to property rentals, lease income, and short-term rental platforms such as airbnb and VRBO.",
  },
  INCOME_RETIREMENT_PENSION: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Retirement Pension",
    description:
      "Payments from the social security administration, private retirement systems, (eg. 401k) pensions, and government retirement programs",
  },
  INCOME_SALARY: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Salary",
    description: "Income from salaries and wages",
  },
  INCOME_TAX_REFUND: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Tax Refund",
    description: "Government tax refund provided to the user",
  },
  INCOME_UNEMPLOYMENT: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Unemployment",
    description: "Money earned from unemployment benefits",
  },
  INCOME_OTHER: {
    primary: "INCOME",
    primary_friendly: "Income",
    detailed_friendly: "Other",
    description: "Other miscellaneous income",
  },
  LOAN_DISBURSEMENTS_AUTO: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Auto",
    description: "Auto loan disbursements",
  },
  LOAN_DISBURSEMENTS_CASH_ADVANCES: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Cash Advances",
    description: "Payday loans and cash advances",
  },
  LOAN_DISBURSEMENTS_EWA: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "EWA",
    description:
      "Early wage access disbursements from integrated payroll providers.",
  },
  LOAN_DISBURSEMENTS_MORTGAGE: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Mortgage",
    description: "Mortgage loan disbursements",
  },
  LOAN_DISBURSEMENTS_PERSONAL: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Personal",
    description:
      "Personal loan disbursements, including both secured and unsecured loans.",
  },
  LOAN_DISBURSEMENTS_STUDENT: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Student",
    description: "Student loan disbursements.",
  },
  LOAN_DISBURSEMENTS_OTHER_DISBURSEMENT: {
    primary: "LOAN_DISBURSEMENTS",
    primary_friendly: "Loan Disbursements",
    detailed_friendly: "Other Disbursement",
    description: "Other miscellaneous loan disbursements",
  },
  LOAN_PAYMENTS_BNPL: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "BNPL",
    description: "Loan payments for buy now, pay later (BNPL) services.",
  },
  LOAN_PAYMENTS_CAR_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Car Payment",
    description: "Payments on car loans and leases.",
  },
  LOAN_PAYMENTS_CASH_ADVANCES: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Cash Advances",
    description: "Loan payments for cash advances.",
  },
  LOAN_PAYMENTS_CREDIT_CARD_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Credit Card Payment",
    description: "Payments made to a credit card account.",
  },
  LOAN_PAYMENTS_EWA: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "EWA",
    description:
      "Loan payments for early wage access from integrated payroll providers.",
  },
  LOAN_PAYMENTS_MORTGAGE_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Mortgage Payment",
    description: "Payments on mortgages",
  },
  LOAN_PAYMENTS_PERSONAL_LOAN_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Personal Loan Payment",
    description: "Payments on personal loans.",
  },
  LOAN_PAYMENTS_STUDENT_LOAN_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Student Loan Payment",
    description:
      'Payments on student loans. For college tuition, refer to "General Services - Education"',
  },
  LOAN_PAYMENTS_OTHER_PAYMENT: {
    primary: "LOAN_PAYMENTS",
    primary_friendly: "Loan Payments",
    detailed_friendly: "Other Payment",
    description: "Other miscellaneous debt payments",
  },
  TRANSFER_IN_ACCOUNT_TRANSFER: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Account Transfer",
    description: "General inbound transfers from another account",
  },
  TRANSFER_IN_DEPOSIT: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Deposit",
    description: "Cash, checks, and ATM deposits into a bank account",
  },
  TRANSFER_IN_INVESTMENT_AND_RETIREMENT_FUNDS: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Investment and Retirement Funds",
    description:
      "Money transferred into the account from an investment or retirement account",
  },
  TRANSFER_IN_SAVINGS: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Savings",
    description: "Inbound transfers to a savings account",
  },
  TRANSFER_IN_TRANSFER_IN_FROM_APPS: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Transfer In from Apps",
    description: "Money transferred into the account from another application",
  },
  TRANSFER_IN_WIRE: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Wire",
    description:
      "Money transferred into the account from a wire transfer from another bank",
  },
  TRANSFER_IN_OTHER_TRANSFER_IN: {
    primary: "TRANSFER_IN",
    primary_friendly: "Transfer In",
    detailed_friendly: "Other Transfer In",
    description: "Other miscellaneous inbound transactions",
  },
  TRANSFER_OUT_ACCOUNT_TRANSFER: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Account Transfer",
    description: "General outbound transfers to another account",
  },
  TRANSFER_OUT_CRYPTO: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Crypto",
    description: "Outbound transfers of cryptocurrency",
  },
  TRANSFER_OUT_INVESTMENT_AND_RETIREMENT_FUNDS: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Investment and Retirement Funds",
    description:
      "Transfers to an investment or retirement account, including investment apps such as Acorns, Betterment",
  },
  TRANSFER_OUT_SAVINGS: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Savings",
    description: "Outbound transfers to savings accounts",
  },
  TRANSFER_OUT_TRANSFER_OUT_FROM_APPS: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Transfer Out from Apps",
    description:
      "Money transferred out of the account into another application",
  },
  TRANSFER_OUT_WIRE: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Wire",
    description:
      "Money transferred out of the account from a wire transfer to another bank",
  },
  TRANSFER_OUT_WITHDRAWAL: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Withdrawal",
    description: "Withdrawals from a bank account",
  },
  TRANSFER_OUT_OTHER_TRANSFER_OUT: {
    primary: "TRANSFER_OUT",
    primary_friendly: "Transfer Out",
    detailed_friendly: "Other Transfer Out",
    description: "Other miscellaneous outbound transactions",
  },
  BANK_FEES_ATM_FEES: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "ATM Fees",
    description: "Fees incurred for out-of-network ATMs",
  },
  BANK_FEES_INSUFFICIENT_FUNDS: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Insufficient Funds",
    description: "Fees relating to insufficient funds",
  },
  BANK_FEES_INTEREST_CHARGE: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Interest Charge",
    description:
      "Fees incurred for interest on purchases (this excludes cash advance interest fee)",
  },
  BANK_FEES_FOREIGN_TRANSACTION_FEES: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Foreign Transaction Fees",
    description: "Fees incurred on non-domestic transactions",
  },
  BANK_FEES_OVERDRAFT_FEES: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Overdraft Fees",
    description: "Penalty payment for overdrafts",
  },
  BANK_FEES_LATE_FEES: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Late Fees",
    description: "Penalty payment for late payment",
  },
  BANK_FEES_CASH_ADVANCE: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Cash Advance",
    description:
      "Fees incurred for withdrawing cash using a credit card, including transaction fees and interest fees.",
  },
  BANK_FEES_OTHER_BANK_FEES: {
    primary: "BANK_FEES",
    primary_friendly: "Bank Fees",
    detailed_friendly: "Other Bank Fees",
    description: "Other miscellaneous bank fees, including annual fee",
  },
  ENTERTAINMENT_CASINOS_AND_GAMBLING: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "Casinos and Gambling",
    description: "Gambling, casinos, and sports betting",
  },
  ENTERTAINMENT_MUSIC_AND_AUDIO: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "Music and Audio",
    description:
      "Digital and in-person music purchases, including music streaming services",
  },
  ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "Sporting Events Amusement Parks and Museums",
    description:
      "Purchases made at sporting events, music venues, concerts, museums, and amusement parks",
  },
  ENTERTAINMENT_TV_AND_MOVIES: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "TV and Movies",
    description: "In home movie streaming services and movie theaters",
  },
  ENTERTAINMENT_VIDEO_GAMES: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "Video Games",
    description: "Digital and in-person video game purchases",
  },
  ENTERTAINMENT_OTHER_ENTERTAINMENT: {
    primary: "ENTERTAINMENT",
    primary_friendly: "Entertainment",
    detailed_friendly: "Other Entertainment",
    description:
      "Other miscellaneous entertainment purchases, including night life and adult entertainment",
  },
  FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Beer Wine and Liquor",
    description: "Beer, wine, and liquor stores.",
  },
  FOOD_AND_DRINK_COFFEE: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Coffee",
    description: "Purchases at coffee shops or cafes",
  },
  FOOD_AND_DRINK_FAST_FOOD: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Fast Food",
    description: "Dining expenses for fast food chains",
  },
  FOOD_AND_DRINK_GROCERIES: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Groceries",
    description:
      "Purchases for fresh produce and groceries, including farmers' markets",
  },
  FOOD_AND_DRINK_RESTAURANT: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Restaurant",
    description:
      "Dining expenses for restaurants, bars, gastropubs, and diners",
  },
  FOOD_AND_DRINK_VENDING_MACHINES: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Vending Machines",
    description: "Purchases made at vending machine operators",
  },
  FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK: {
    primary: "FOOD_AND_DRINK",
    primary_friendly: "Food and Drink",
    detailed_friendly: "Other Food and Drink",
    description:
      "Other miscellaneous food and drink, including desserts, juice bars, and delis",
  },
  GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Bookstores and Newsstands",
    description: "Books, magazines, and news",
  },
  GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Clothing and Accessories",
    description: "Apparel, shoes, and jewelry",
  },
  GENERAL_MERCHANDISE_CONVENIENCE_STORES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Convenience Stores",
    description: "Purchases at convenience stores",
  },
  GENERAL_MERCHANDISE_DEPARTMENT_STORES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Department Stores",
    description:
      "Retail stores with wide ranges of consumer goods, typically specializing in clothing and home goods",
  },
  GENERAL_MERCHANDISE_DISCOUNT_STORES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Discount Stores",
    description: "Stores selling goods at a discounted price",
  },
  GENERAL_MERCHANDISE_ELECTRONICS: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Electronics",
    description: "Electronics stores and websites",
  },
  GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Gifts and Novelties",
    description: "Photo, gifts, cards, and floral stores",
  },
  GENERAL_MERCHANDISE_OFFICE_SUPPLIES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Office Supplies",
    description: "Stores that specialize in office goods",
  },
  GENERAL_MERCHANDISE_ONLINE_MARKETPLACES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Online Marketplaces",
    description:
      "Multi-purpose e-commerce platforms such as Etsy, Ebay and Amazon",
  },
  GENERAL_MERCHANDISE_PET_SUPPLIES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Pet Supplies",
    description: "Pet supplies and pet food",
  },
  GENERAL_MERCHANDISE_SPORTING_GOODS: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Sporting Goods",
    description: "Sporting goods, camping gear, and outdoor equipment",
  },
  GENERAL_MERCHANDISE_SUPERSTORES: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Superstores",
    description:
      "Superstores such as Target and Walmart, selling both groceries and general merchandise",
  },
  GENERAL_MERCHANDISE_TOBACCO_AND_VAPE: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Tobacco and Vape",
    description: "Purchases for tobacco and vaping products",
  },
  GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE: {
    primary: "GENERAL_MERCHANDISE",
    primary_friendly: "General Merchandise",
    detailed_friendly: "Other General Merchandise",
    description:
      "Other miscellaneous merchandise, including toys, hobbies, and arts and crafts",
  },
  HOME_IMPROVEMENT_FURNITURE: {
    primary: "HOME_IMPROVEMENT",
    primary_friendly: "Home Improvement",
    detailed_friendly: "Furniture",
    description: "Furniture, bedding, and home accessories",
  },
  HOME_IMPROVEMENT_HARDWARE: {
    primary: "HOME_IMPROVEMENT",
    primary_friendly: "Home Improvement",
    detailed_friendly: "Hardware",
    description: "Building materials, hardware stores, paint, and wallpaper",
  },
  HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE: {
    primary: "HOME_IMPROVEMENT",
    primary_friendly: "Home Improvement",
    detailed_friendly: "Repair and Maintenance",
    description: "Plumbing, lighting, gardening, and roofing",
  },
  HOME_IMPROVEMENT_SECURITY: {
    primary: "HOME_IMPROVEMENT",
    primary_friendly: "Home Improvement",
    detailed_friendly: "Security",
    description: "Home security system purchases",
  },
  HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT: {
    primary: "HOME_IMPROVEMENT",
    primary_friendly: "Home Improvement",
    detailed_friendly: "Other Home Improvement",
    description:
      "Other miscellaneous home purchases, including pool installation and pest control",
  },
  MEDICAL_DENTAL_CARE: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Dental Care",
    description: "Dentists and general dental care",
  },
  MEDICAL_EYE_CARE: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Eye Care",
    description: "Optometrists, contacts, and glasses stores",
  },
  MEDICAL_NURSING_CARE: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Nursing Care",
    description: "Nursing care and facilities",
  },
  MEDICAL_PHARMACIES_AND_SUPPLEMENTS: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Pharmacies and Supplements",
    description: "Pharmacies and nutrition shops",
  },
  MEDICAL_PRIMARY_CARE: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Primary Care",
    description: "Doctors and physicians",
  },
  MEDICAL_VETERINARY_SERVICES: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Veterinary Services",
    description: "Prevention and care procedures for animals",
  },
  MEDICAL_OTHER_MEDICAL: {
    primary: "MEDICAL",
    primary_friendly: "Medical",
    detailed_friendly: "Other Medical",
    description:
      "Other miscellaneous medical, including blood work, hospitals, and ambulances",
  },
  PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS: {
    primary: "PERSONAL_CARE",
    primary_friendly: "Personal Care",
    detailed_friendly: "Gyms and Fitness Centers",
    description: "Gyms, fitness centers, and workout classes",
  },
  PERSONAL_CARE_HAIR_AND_BEAUTY: {
    primary: "PERSONAL_CARE",
    primary_friendly: "Personal Care",
    detailed_friendly: "Hair and Beauty",
    description:
      "Manicures, haircuts, waxing, spa/massages, and bath and beauty products",
  },
  PERSONAL_CARE_LAUNDRY_AND_DRY_CLEANING: {
    primary: "PERSONAL_CARE",
    primary_friendly: "Personal Care",
    detailed_friendly: "Laundry and Dry Cleaning",
    description: "Wash and fold, and dry cleaning expenses",
  },
  PERSONAL_CARE_OTHER_PERSONAL_CARE: {
    primary: "PERSONAL_CARE",
    primary_friendly: "Personal Care",
    detailed_friendly: "Other Personal Care",
    description:
      "Other miscellaneous personal care, including mental health apps and services",
  },
  GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Accounting and Financial Planning",
    description: "Financial planning, tax, and accounting services.",
  },
  GENERAL_SERVICES_AUTOMOTIVE: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Automotive",
    description: "Oil changes, car washes, repairs, and towing",
  },
  GENERAL_SERVICES_CHILDCARE: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Childcare",
    description: "Babysitters and daycare",
  },
  GENERAL_SERVICES_CONSULTING_AND_LEGAL: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Consulting and Legal",
    description: "Consulting and legal services",
  },
  GENERAL_SERVICES_EDUCATION: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Education",
    description:
      "Elementary, high school, professional schools, and college tuition",
  },
  GENERAL_SERVICES_INSURANCE: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Insurance",
    description: "Insurance for auto, home, and healthcare",
  },
  GENERAL_SERVICES_POSTAGE_AND_SHIPPING: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Postage and Shipping",
    description: "Mail, packaging, and shipping services",
  },
  GENERAL_SERVICES_STORAGE: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Storage",
    description: "Storage services and facilities",
  },
  GENERAL_SERVICES_OTHER_GENERAL_SERVICES: {
    primary: "GENERAL_SERVICES",
    primary_friendly: "General Services",
    detailed_friendly: "Other General Services",
    description:
      "Other miscellaneous services, including advertising and cloud storage",
  },
  GOVERNMENT_AND_NON_PROFIT_DONATIONS: {
    primary: "GOVERNMENT_AND_NON_PROFIT",
    primary_friendly: "Government and Non Profit",
    detailed_friendly: "Donations",
    description: "Charitable, political, and religious donations",
  },
  GOVERNMENT_AND_NON_PROFIT_GOVERNMENT_DEPARTMENTS_AND_AGENCIES: {
    primary: "GOVERNMENT_AND_NON_PROFIT",
    primary_friendly: "Government and Non Profit",
    detailed_friendly: "Government Departments and Agencies",
    description:
      "Government departments and agencies, such as driving licenses, and passport renewal",
  },
  GOVERNMENT_AND_NON_PROFIT_TAX_PAYMENT: {
    primary: "GOVERNMENT_AND_NON_PROFIT",
    primary_friendly: "Government and Non Profit",
    detailed_friendly: "Tax Payment",
    description: "Tax payments, including income and property taxes",
  },
  GOVERNMENT_AND_NON_PROFIT_OTHER_GOVERNMENT_AND_NON_PROFIT: {
    primary: "GOVERNMENT_AND_NON_PROFIT",
    primary_friendly: "Government and Non Profit",
    detailed_friendly: "Other Government and Non Profit",
    description: "Other miscellaneous government and non-profit agencies",
  },
  TRANSPORTATION_BIKES_AND_SCOOTERS: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Bikes and Scooters",
    description: "Bike and scooter rentals",
  },
  TRANSPORTATION_GAS: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Gas",
    description: "Purchases at a gas station",
  },
  TRANSPORTATION_PARKING: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Parking",
    description: "Parking fees and expenses",
  },
  TRANSPORTATION_PUBLIC_TRANSIT: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Public Transit",
    description:
      "Public transportation, including rail and train, buses, and metro",
  },
  TRANSPORTATION_TAXIS_AND_RIDE_SHARES: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Taxis and Ride Shares",
    description: "Taxi and ride share services",
  },
  TRANSPORTATION_TOLLS: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Tolls",
    description: "Toll expenses",
  },
  TRANSPORTATION_OTHER_TRANSPORTATION: {
    primary: "TRANSPORTATION",
    primary_friendly: "Transportation",
    detailed_friendly: "Other Transportation",
    description: "Other miscellaneous transportation expenses",
  },
  TRAVEL_FLIGHTS: {
    primary: "TRAVEL",
    primary_friendly: "Travel",
    detailed_friendly: "Flights",
    description: "Airline expenses",
  },
  TRAVEL_LODGING: {
    primary: "TRAVEL",
    primary_friendly: "Travel",
    detailed_friendly: "Lodging",
    description: "Hotels, motels, and hosted accommodation such as Airbnb",
  },
  TRAVEL_RENTAL_CARS: {
    primary: "TRAVEL",
    primary_friendly: "Travel",
    detailed_friendly: "Rental Cars",
    description: "Rental cars, charter buses, and trucks",
  },
  TRAVEL_OTHER_TRAVEL: {
    primary: "TRAVEL",
    primary_friendly: "Travel",
    detailed_friendly: "Other Travel",
    description: "Other miscellaneous travel expenses",
  },
  RENT_AND_UTILITIES_GAS_AND_ELECTRICITY: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Gas and Electricity",
    description: "Gas and electricity bills",
  },
  RENT_AND_UTILITIES_INTERNET_AND_CABLE: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Internet and Cable",
    description: "Internet and cable bills",
  },
  RENT_AND_UTILITIES_RENT: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Rent",
    description: "Rent payment",
  },
  RENT_AND_UTILITIES_SEWAGE_AND_WASTE_MANAGEMENT: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Sewage and Waste Management",
    description: "Sewage and garbage disposal bills",
  },
  RENT_AND_UTILITIES_TELEPHONE: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Telephone",
    description: "Telephone bills",
  },
  RENT_AND_UTILITIES_WATER: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Water",
    description: "Water bills",
  },
  RENT_AND_UTILITIES_OTHER_UTILITIES: {
    primary: "RENT_AND_UTILITIES",
    primary_friendly: "Rent and Utilities",
    detailed_friendly: "Other Utilities",
    description: "Other miscellaneous utility bills",
  },
  OTHER_OTHER: {
    primary: "OTHER",
    primary_friendly: "Other",
    detailed_friendly: "Other",
    description: "",
  },
  UNKNOWN: {
    primary: "Unknown",
    primary_friendly: "Unknown",
    detailed_friendly: "Unknown",
    description: "Was not able to identify this category",
  },
};

export const primarySpendingCategories = [
  { value: "TRANSFER_OUT", label: "Transfer Out" },
  { value: "LOAN_PAYMENTS", label: "Loan Payments" },
  { value: "BANK_FEES", label: "Bank Fees" },
  { value: "ENTERTAINMENT", label: "Entertainment" },
  { value: "FOOD_AND_DRINK", label: "Food and Drink" },
  { value: "GENERAL_MERCHANDISE", label: "General Merchandise" },
  { value: "HOME_IMPROVEMENT", label: "Home Improvement" },
  { value: "MEDICAL", label: "Medical" },
  { value: "PERSONAL_CARE", label: "Personal Care" },
  { value: "GENERAL_SERVICES", label: "General Services" },
  { value: "GOVERNMENT_AND_NON_PROFIT", label: "Government and Non Profit" },
  { value: "TRANSPORTATION", label: "Transportation" },
  { value: "TRAVEL", label: "Travel" },
  { value: "RENT_AND_UTILITIES", label: "Rent and Utilities" },
];
